"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Page = Page;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _layout = require("../layout");
var _CodeFromMailForm = require("./CodeFromMailForm");
var _EmailForm = require("./EmailForm");
var _PasswordForm = require("./PasswordForm");
var _ui = require("../../ui");
var _hooks = require("../../../hooks");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledLayoutBodyWizardControl = (0, _styledComponents.default)(_layout.LayoutBodyWizardControl)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
function Page(_ref) {
  var successPath = _ref.successPath;
  var _useTranslation = (0, _reactI18next.useTranslation)('libAuth'),
    t = _useTranslation.t;
  var _useRestorePasswordWi = (0, _hooks.useRestorePasswordWithWizard)({
      successPath: successPath
    }),
    step = _useRestorePasswordWi.step,
    setStep = _useRestorePasswordWi.setStep,
    restore = _useRestorePasswordWi.restore,
    loading = _useRestorePasswordWi.loading,
    redirectToSuccessPath = _useRestorePasswordWi.redirectToSuccessPath,
    _useRestorePasswordWi2 = _useRestorePasswordWi.code,
    send = _useRestorePasswordWi2.send,
    sendLoading = _useRestorePasswordWi2.sendLoading,
    remainingTime = _useRestorePasswordWi2.remainingTime,
    validate = _useRestorePasswordWi2.validate;
  return /*#__PURE__*/_react.default.createElement(_ui.Wizard, {
    step: step,
    setStep: setStep
  }, /*#__PURE__*/_react.default.createElement(_ui.WizardStep, {
    order: 0
  }, /*#__PURE__*/_react.default.createElement(_layout.LayoutBackTitle, {
    onClick: redirectToSuccessPath
  }, t('backToLogin'))), /*#__PURE__*/_react.default.createElement(_ui.WizardStep, {
    order: 1
  }, /*#__PURE__*/_react.default.createElement(_layout.LayoutBackTitle, {
    onClick: redirectToSuccessPath
  }, t('backToLogin'))), /*#__PURE__*/_react.default.createElement(_ui.WizardStep, {
    order: 2
  }, /*#__PURE__*/_react.default.createElement(_layout.LayoutBackTitle, {
    onClick: function onClick() {
      return setStep(1);
    }
  }, t('back'))), /*#__PURE__*/_react.default.createElement(StyledLayoutBodyWizardControl, {
    steps: 3
  }), /*#__PURE__*/_react.default.createElement(_layout.LayoutBodyCard, null, /*#__PURE__*/_react.default.createElement(_ui.CardBody, null, /*#__PURE__*/_react.default.createElement(_ui.WizardStep, {
    order: 0
  }, /*#__PURE__*/_react.default.createElement(_EmailForm.EmailForm, {
    contactSupportLink: process.env.REACT_APP_CHAT,
    sendCodeLoading: sendLoading,
    onSubmit: function onSubmit(_ref2) {
      var email = _ref2.email;
      return send(email);
    }
  })), /*#__PURE__*/_react.default.createElement(_ui.WizardStep, {
    order: 1
  }, /*#__PURE__*/_react.default.createElement(_CodeFromMailForm.CodeFromMailForm, {
    onSubmit: function onSubmit(_ref3) {
      var code = _ref3.code;
      return validate(code);
    },
    contactSupportLink: process.env.REACT_APP_CHAT,
    send: send,
    sendLoading: sendLoading,
    sendTimeout: remainingTime
  })), /*#__PURE__*/_react.default.createElement(_ui.WizardStep, {
    order: 2
  }, /*#__PURE__*/_react.default.createElement(_PasswordForm.PasswordForm, {
    onSubmit: function onSubmit(_ref4) {
      var password = _ref4.password;
      return restore(password);
    },
    submitLoading: loading
  })))));
}